<template id="user">
  <div>
    <div v-if="addNew == 'true'" class="vx-row">
            <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
        <vs-input
          class="w-full"
          v-validate="'required'"
          :label="$t('Firstname') |ToUppercase"
          type="text"
          v-model="user.firstname"
          name="firstname"
          @keyup="updateUsername"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.firstname`)"
        >{{ errors.first(`${vvFormScope}.firstname`) }}</span>
      </div>      
      <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
        <vs-input
          class="w-full"
          v-validate="'required'"
          :label="$t('Lastname') |ToUppercase"
          type="text"
          v-model="user.lastname"
          name="lastname"
          @keyup="updateUsername"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.lastname`)"
        >{{ errors.first(`${vvFormScope}.lastname`) }}</span>
      </div>
      <div class="vx-col sm:w-1/1 md:w-1/3 w-full">
        <vs-input
          v-validate="'required'"
          class="w-full"
          type="text"
          name="username"
          :label="$t('Username') | ToUppercase"
          v-model="user.username"
          :danger="state"
          :success="!state"
          :danger-text="$t('UsernameExsist')"
          val-icon-danger="report_problem"
          @keyup="checkUsername"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.username`)"
        >{{ errors.first(`${vvFormScope}.username`) }}</span>
      </div>
    </div>
    <div v-if="addNew  == 'false'" class="vx-row">
            <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
        <vs-input
          class="w-full"
          v-validate="'required'"
          :label="$t('Firstname') |ToUppercase"
          type="text"
          v-model="user.firstname"
          name="firstname"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.firstname`)"
        >{{ errors.first(`${vvFormScope}.firstname`) }}</span>
      </div>      
      <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
        <vs-input
          class="w-full"
          v-validate="'required'"
          :label="$t('Lastname') |ToUppercase"
          type="text"
          v-model="user.lastname"
          name="lastname"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.lastname`)"
        >{{ errors.first(`${vvFormScope}.lastname`) }}</span>
      </div>
      <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
        <vs-input
          v-validate="'required'"
          class="w-full"
          type="text"
          name="username"
          :label="$t('Username') | ToUppercase"
          v-model="user.username"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.username`)"
        >{{ errors.first(`${vvFormScope}.username`) }}</span>
      </div>
      <div class="vx-col sm:w-1/1 md:w-1/4 w-full">
        <vs-input
          class="w-full"
          type="text"
          name="email"
          :label="$t('Email') | ToUppercase"
          v-model="user.email"
        />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
        <vs-input
          class="w-full"
          :label="$t('Password') | ToUppercase"
          :v-validate="{passReq}"
          type="password"
          name="password"
          v-model="user.password"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.password`)"
        >{{ errors.first(`${vvFormScope}.password`) }}</span>
      </div>      
      <div class="vx-col sm:w-1/1 md:w-1/2 w-full">
        <vs-input
          class="w-full"
          :label="$t('RepeatPassword') |ToUppercase"
          :v-validate="{passReq}"
          type="password"
          name="repeatPassword"
          v-model="user.repeatPassword"
        />
        <span
          class="text-danger"
          v-show="errors.has(`${vvFormScope}.repeatPassword`)"
        >{{ errors.first(`${vvFormScope}.repeatPassword`) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["$validator"],
  name: "user-component",
  template: "#user",
  props: {
    user: {
      type: Object
    },
    vvFormScope: {
      type: String
    },
    passReq: {
      type: String
    },
    addNew: {
      type: String
    }
  },
  data() {
    return {
      state: false
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
    ToLowercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toLowerCase();
    },
  },
  methods: {
    updateUsername(){
      this.user.username = this.user.firstname + this.user.lastname;
      this.user.username = this.user.username.toLowerCase();
      this.checkUsername();
    },
    async checkUsername(){
      let res = await this.$store.dispatch("admin/checkUsername", this.user.username);
      if(res.data){
        this.state=true
      }else{
        this.state=false
      }
    }
  }
};
</script>